// extracted by mini-css-extract-plugin
var _1 = "RichTextDescriptionControl-module__animateUploadProgressBarWidth--hJ81_";
var _2 = "RichTextDescriptionControl-module__animatedBackground--LptQI";
var _3 = "RichTextDescriptionControl-module__disabled--TdWwd";
var _4 = "RichTextDescriptionControl-module__editor--X_uub";
var _5 = "RichTextDescriptionControl-module__editorContainer--xXvcJ";
var _6 = "RichTextDescriptionControl-module__error--bwVmX";
var _7 = "RichTextDescriptionControl-module__expanded--HCuKY";
var _8 = "RichTextDescriptionControl-module__label--ddKSA";
var _9 = "RichTextDescriptionControl-module__tip--B5Z3h";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "disabled", _4 as "editor", _5 as "editorContainer", _6 as "error", _7 as "expanded", _8 as "label", _9 as "tip" }
